import CampAttendanceIndex from './CampAttendanceIndex';
import CampAttendanceCreate from './CampAttendanceCreate';
import CampAttendanceSettings from './CampAttendanceSettings';
import CampAttendanceSingle from './CampAttendanceSingle';

export default function (app) {

    const settings = CampAttendanceSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    CampAttendanceIndex(app, settings);

    CampAttendanceCreate(app, settings);

    CampAttendanceSingle(app, settings);

}